// Central API layer – routed entirely through the Firestore service
import firestoreApi from './firestoreApi';

const api = firestoreApi;

export default api;

export const properties = api.properties;
export const vendors = api.vendors;
export const users = api.users;
export const categories = api.categories;
export const search = api.search;
export const analytics = api.analytics;
export const landing = api.landing;
export const storage = api.storage;
export const geocoding = api.geocoding;
